export default "__VITE_ASSET__c7a396ce__"